<template>
  <div class="database-task">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">
        Neues Element in Datenbank speichern
      </div>
      <div class="content">
        <div class="header">
          <div class="row">
            <div class="filename-wrapper col-4">
              <input
                type="text"
                v-model="task.props.databaseName"
                class="props-input"
                ref="report-name"
                placeholder="Definieren Sie den Namen für das Resultat"
                :class="{ 'is-duplicate': isNameDuplicate(), error: shakeName }"
              />
            </div>
            <div
              v-click-outside="hideSearch"
              class="search-wrapper"
              ref="searchBox"
              :class="{ active: searchActive }"
            >
              <div class="search-btn" @click="toggleSearch">
                <img src="../../assets/img/search-icon.svg" />
              </div>
              <input class="search-input" ref="search" v-model="search" />
            </div>
          </div>
        </div>
        <div class="database-drop-down">
          <div class="tab">
            <SelectDatabase
              :selectedDatabaseCaption="selectedDatabaseCaption"
              :selectedDatabaseName="selectedDatabaseName"
              :userTables="userTables"
              componentName="put-item"
              @onDatabaseSelect="onDatabaseSelect"
              :isUserHasAccess="isUserHasAccess"
            />
          </div>
        </div>
        <div class="button-wrapper">
          <button
            v-if="isAutoFillButtonVisible"
            class="auto-fill-button"
            @click="onAutoFillObjectMapperValue"
            :disabled="!isUserHasAccess"
          >
            Automatisch befüllen
          </button>
        </div>
        <div
          class="tab item-content-wrapper fancy-scroll"
          @scroll.passive="showScrollbar"
        >
          <LoadingSpinner v-if="isLoading" loadingCaption="loading schema" />
          <div v-else>
            <ObjectMapper
              v-if="selectedDatabaseSchema"
              ref="objectMapperRef"
              :task="task"
              :databaseSchema="selectedDatabaseSchema"
              :defaultItems="getObjectMappingDefaultItems"
              :isUserHasAccess="isUserHasAccess"
              :flowRunnerEndpoint="flowRunnerEndpoint"
              :search="search"
              :isSearchEnabled="true"
            ></ObjectMapper>
          </div>
        </div>
        <button
          class="btn"
          @click="toggleModal(true)"
          :disabled="apiLoading || !selectedDatabaseSchema || !isUserHasAccess"
        >
          <span v-if="!apiLoading">Element hinzufügen</span>
          <div class="custom-table-progress-icon" v-if="apiLoading"></div>
        </button>
        <CommonModal
          v-if="addItemModal.isShow"
          :buttons="addItemModal.buttons"
          :closeIconVisible="true"
          header="choose-format-message"
          @close="toggleModal()"
          @handleAddItem="handleAddItem"
          @toggleModal="toggleModal()"
        >
          <template v-slot:choose-format-message>
            <p class="choose-format-message">
              Sind Sie sicher, dass Sie dieses Element zur Datenbank hinzufügen
              möchten?
            </p>
          </template>
        </CommonModal>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import ObjectMapper from '../widgets/object-mapper.vue';
import {
  addTableItem,
  getDataBaseTableSchema,
  getUserDatabases,
} from '../../services/userTable';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters, mapActions } from 'vuex';
import {
  isValidTaskName,
  debouncer,
  getPlaceHolderValue,
} from '@/utils/helpers';
import { getDefaultTaskName } from '@/utils/helpers/WorkFlowHelpers.js';
import SelectDatabase from '../../components/SelectDatabase.vue';
import CommonModal from '../modals/CommonModal.vue';

export default {
  name: 'Database',
  data() {
    return {
      isLoading: false,
      apiLoading: false,
      userTables: [],
      options: [
        { value: 'read', text: 'Lesen' },
        { value: 'write', text: 'Erstellen' },
        { value: 'edit', text: 'Bearbeiten' },
        { value: 'delete', text: 'Loschen' },
      ],
      selectedDatabaseName: null,
      selectedDatabaseSchema: null,
      selectedDatabaseCaption: null,
      shakeName: false,
      addItemApiResponse: null,
      addItemModal: {
        isShow: false,
        buttons: [
          {
            text: 'Ja',
            action: 'handleAddItem',
            loading: false,
          },
          {
            text: 'Abbrechen',
            action: 'toggleModal',
            loading: false,
          },
        ],
      },
      searchActive: false,
      search: '',
    };
  },
  props: {
    task: Object,
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
    isUserHasAccess: {
      type: Boolean,
      required: false,
      default: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  methods: {
    ...mapActions(['setDatabaseSchema']),
    close: function () {
      try {
        if (
          this.isNameDuplicate() ||
          !this.task.props.databaseName ||
          this.task.props.databaseName === null ||
          this.task.props.databaseName.trim() === '' ||
          !isValidTaskName(this.task.props.databaseName)
        ) {
          this.shakeName = true;
          setTimeout(() => {
            this.shakeName = false;
          }, 500);
          return;
        }
        let outputResponse = {
          label: this.task.props.databaseName,
          name: this.task.props.databaseName,
          type: 'number',
          value: this.addItemApiResponse ? this.addItemApiResponse : null,
        };
        this.task.output = [];

        let outputObjectIndex = [...this.task.output].findIndex(
          (ele) =>
            ele.name === this.task.props.databaseName &&
            ele.label === this.task.props.databaseName
        );
        this.$set(
          this.task,
          'output',
          this.task.output.concat(this.task.input)
        );
        if (outputObjectIndex > -1) {
          this.task.output[outputObjectIndex] = outputResponse;
        } else {
          this.task.output.push(outputResponse);
        }
        this.task.props.database = this.selectedDatabaseName;
        this.task.props.item = this?.$refs.objectMapperRef?.getOutputJson;
        this.$emit('close');
      } catch (error) {
        outputResponse.value = error?.data || error?.message || '';
      } finally {
        this.isLoading = false;
      }
    },
    async onDatabaseSelect(database) {
      this.search = '';
      const selectedDatabase = this.userTables.find(
        (userTable) => userTable.name.trim() === database.name.trim()
      );
      if (!selectedDatabase) return;
      try {
        if (!selectedDatabase?.schema) {
          this.isLoading = true;
          const response = await getDataBaseTableSchema(selectedDatabase.name);
          this.setDatabaseSchema(response.data);
          this.selectedDatabaseSchema = response.data.data;
        } else {
          this.selectedDatabaseSchema = selectedDatabase.schema;
        }
        this.selectedDatabaseName = selectedDatabase.name;
        this.selectedDatabaseCaption = selectedDatabase.caption;
      } catch (error) {
        //
      } finally {
        this.isLoading = false;
      }
    },

    onAutoFillObjectMapperValue() {
      this?.$refs.objectMapperRef?.onAutoFill();
    },
    isNameDuplicate() {
      const htmlFilenames = this.getFileNamesFromProps(this.task.id);
      return htmlFilenames.includes(this.task.props.databaseName);
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    async handleAddItem() {
      try {
        this.toggleModal();
        this.apiLoading = true;

        const jsonObject = this?.$refs.objectMapperRef?.getOutputJson;
        if (jsonObject) this.task.props.item = jsonObject;
        let databaseFieldValue = {};
        JSON.parse(this.selectedDatabaseSchema).forEach((item) => {
          databaseFieldValue[item.name] = this.getPayloadId(item.name);
        });

        const item = { ...databaseFieldValue };

        const response = await addTableItem(this.selectedDatabaseName, {
          item: item,
        });

        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.item_id
        ) {
          this.addItemApiResponse = response.data.item_id;
        }
      } catch (error) {
        this.$emit(
          'showToaster',
          'Fehler beim Hinzufügen eines Elements zur ausgewählten Datenbank',
          'Fehler',
          'danger'
        );
      } finally {
        this.apiLoading = false;
      }
    },
    getPayloadId(databaseKey) {
      try {
        if (databaseKey !== null) {
          const itemValue = this.task?.props?.item[databaseKey];
          if (itemValue) {
            return getPlaceHolderValue(itemValue, this.task.input);
          }
          return null;
        }
        return databaseKey;
      } catch (error) {
        console.log(error, 'error');
      }
    },
    toggleModal(bool = false) {
      this.addItemModal.isShow = bool;
    },
    toggleSearch() {
      this.searchActive = true;
      if (this.searchActive) {
        this.$refs.search.focus();
      }
    },
    hideSearch() {
      if (this.search.trim() === '') {
        this.$refs.search.blur();
        this.search = '';
        this.searchActive = false;
      }
    },
  },
  computed: {
    ...mapGetters({ databaseList: 'getDatabaseList' }),
    user() {
      return store.state.user;
    },
    filterDataBase() {
      if (this.userTables.length) {
        return this.userTables;
      }

      return [];
    },
    getObjectMappingDefaultItems() {
      if (this.selectedDatabaseName == this.task.props.database)
        return this.task.props.item;
      return {};
    },
    isAutoFillButtonVisible() {
      return this.selectedDatabaseSchema && this.task?.input?.length;
    },
  },
  async created() {
    try {
      let customTables;
      if (this.databaseList.length) {
        customTables = this.databaseList;
      } else {
        customTables = await getUserDatabases();
      }
      this.userTables = customTables.filter(
        (database) =>
          database.type === 'custom' &&
          !['read'].includes(database.access_level)
      );

      if (this.task.props.database) {
        await this.onDatabaseSelect({ name: this.task.props.database });
      }
      if (JSON.parse(this.selectedDatabaseSchema) && this.task.props.item) {
        const expandedSchema = JSON.parse(this.selectedDatabaseSchema)
          .filter((item) => !this.task.props.item.hasOwnProperty(item.name))
          .map((item) => item.label);

        if (expandedSchema.length) {
          const div = this.$createElement;

          const warnignMessage = div('div', {}, [
            div(
              'span',
              { class: ['h6', 'text-justify'] },
              'Das Schema wurde seit der letzen Anpassung erweitert. Folgende Einträge sind dazu gekommen.'
            ),
            div(
              'ul',
              { class: 'mb-0' },
              expandedSchema.map((item) => div('li', item))
            ),
          ]);

          this.$emit('showToaster', [warnignMessage], 'Hinweis', 'warning');
        }
      }
      if (!this.task?.props?.databaseName) {
        const existingTaskNames = this.getFileNamesFromProps(this.task.id);
        this.task.props.databaseName = getDefaultTaskName(
          existingTaskNames,
          'Database_Antwort'
        );
      }
    } catch (error) {
      //
    }
  },
  components: {
    ObjectMapper,
    GeneralDropdown,
    LoadingSpinner,
    SelectDatabase,
    CommonModal,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.database-task {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.database-task .heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.database-task .content {
  margin-top: 17px;
  background-color: #fff;
  width: 100%;
  height: calc(100% - 36px - 7px);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.database-task h1 {
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

.database-task h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.database-task h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.database-task .tab {
  text-align: left;
  padding: 20px 0px;
  width: 100%;
}

.database-task input,
.database-task select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 30px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 19px;
  font-weight: 300;
}

.database-task select {
  width: 70%;
}

.database-task .date {
  width: 53%;
}

.database-task .time {
  width: 33%;
}

.database-task .textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

.database-task button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

.database-task button.default {
  color: #464d5d;
  background: #fff;
}
.database-task.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.database-task .pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.database-task .btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.database-task ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.database-task .modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.database-task .modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.database-task .modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.database-task .modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

.database-task a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

.database-task a {
  background-color: transparent;
}

.database-task .modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.database-task .modal ul.tabsLabels a.active,
.database-task .modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.database-task .tabsLabels .datetime {
}

.database-task .tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.database-task .tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

.database-task p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.database-task .systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.database-task .item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.database-task .item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.database-task .systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.database-task .img-wrapper {
  width: 100%;
  height: 111px;
}

.database-task .systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.database-task .database-drop-down {
  display: flex;
  margin-top: 36px;
}

.database-task .modal .database-modal {
  position: absolute;
  right: 10px;
  top: 10px;
}

.database-task .modal .database-modal .btn-close {
  margin-left: auto;
}

.database-task .auto-fill-button {
  height: 45px;
  width: max-content;
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: pointer;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin: 0;
  text-transform: none;
}

.database-task .button-wrapper {
  text-align: center;
}
.database-task .auto-fill-button:active {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.database-task .modal .header .row {
  --bs-gutter-x: 0;
}
.database-task .modal .header .filename-wrapper {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #464d5d;
  padding: 0px;
}

.database-task .header .props-input {
  font-size: 15px !important;
  line-height: 28px !important;
  cursor: text !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  color: #000 !important;
  border: 1px solid #e2e2e2 !important;
  border-radius: 6px !important;
  padding: 12px 12px !important;
  height: 38px !important;
}
.database-task .header .props-input:focus {
  outline: none;
}
.database-task .header .is-duplicate {
  background: #ff050578;
}
.database-task .header .error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}
@keyframes shake {
  0% {
    margin-left: 2rem;
  }
  25% {
    margin-left: 2.2rem;
  }
  75% {
    margin-left: 1.8rem;
  }
  100% {
    margin-left: 2rem;
  }
}

.content .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px !important;
  position: absolute;
  bottom: 30px;
}
.content .btn:hover {
  border-color: #dee3e9 !important;
}

.content button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

.content .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #555555;
  border-color: #555555 transparent #555555 transparent;
  margin-left: 10px;
  animation: progress-icon-animation 1.2s linear infinite;
}

.content .choose-format-message {
  font-size: 16px;
}

.database-task .content:has(.button-wrapper) .object-mapper {
  max-height: calc(100dvh - 560px);
  min-height: calc(100dvh - 560px);
}

.database-task
  .modal.task
  .content
  .tab
  ::v-deep
  .loading
  .progress-icon-wrapper {
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  -webkit-transform: translate(-50%, 0) !important;
  transform: translate(-50%, 0%) !important;
  bottom: auto !important;
  right: auto !important;
}

.database-task .search-wrapper {
  border: none;
  outline: none;
  border-radius: 5px;
  width: fit-content;
  transition: all 0.5s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 0 0 auto !important;
  position: relative;
  min-width: 40px;
}

.database-task .search-wrapper .search-input {
  border: 1px solid transparent;
  outline: none;
  height: 36px !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 0;
  max-width: 260px;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;
  display: flex;
  align-items: center;
  font-size: 15px !important;
  border-radius: 5px;
  overflow: hidden;
}

.database-task .search-wrapper.active .search-input {
  width: 260px;
  padding-inline: 38px 15px !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.database-task .search-wrapper .search-btn {
  border: none;
  outline: none;
  background-color: transparent;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.database-task .search-wrapper .search-btn img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  object-position: center;
}
</style>
